import { useState } from 'react';
import './Calculator.scss';
import Input, { Group, Label, Radio } from './Input';
import { Col, Row } from './Grid';
import { priceWithoutTaxes, priceWithTaxes, taxesFromPriceWithTaxes, taxesFromTaxlessPrice } from '../utils/vat';
import { normalizeFloat } from '../utils/numbers';
import Name from './Calculator/Name';
import Result from './Calculator/Result';
import Button from './Button';

function Calculator({ id, isLast, onRemove, onAdd }) {
  const [tax, setTax] = useState('25,5');
  const [price, setPrice] = useState('125,5');
  const [isTaxless, setIsTaxless] = useState(false);

  let cleanTax = normalizeFloat(tax);
  const cleanPrice = normalizeFloat(price);

  let taxPrice = 0;
  let taxlessPrice = 0
  let taxes = 0;

  if (cleanTax && cleanPrice) {
    taxPrice = (isTaxless) ? priceWithTaxes(cleanPrice, cleanTax) : cleanPrice;
    taxlessPrice = (isTaxless) ? cleanPrice : priceWithoutTaxes(cleanPrice, cleanTax);
    taxes = (isTaxless) ? taxesFromTaxlessPrice(cleanPrice, cleanTax) : taxesFromPriceWithTaxes(cleanPrice, cleanTax);
  } else if (!cleanTax) {
    cleanTax = 0;
  }

  return (
    <div className="calculator">
      <Name initial="Laskuri" />

      <Row>
        <Col size="8">
          <Group>
            <Label>Verokanta</Label>
            <Input
              type="text"
              value={tax}
              onChange={(e) => setTax(e.target.value)}
            />
          </Group>

          <Group>
            <Label>Hinta</Label>
            <Input
              type="text"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
          </Group>

          <Radio checked={!isTaxless} onChange={(e) => setIsTaxless(false)} />
          <span style={{ marginRight: 'var(--spacing)' }}>Verollinen</span>

          <Radio checked={isTaxless} onChange={(e) => setIsTaxless(true)} />
          <span>Veroton</span>
        </Col>

        <Col size="4">
          <Result
            tax={cleanTax}
            taxPrice={taxPrice}
            taxlessPrice={taxlessPrice}
            taxes={taxes}
          />
        </Col>
      </Row>

      <div className="calculator-buttons">
        {isLast ? (
          <Button onClick={() => onAdd()}>
            +
          </Button>
        ) : (
          <Button onClick={() => onRemove(id)}>
            &times;
          </Button>
        )}
      </div>
    </div>
  );
}



export default Calculator;
